export const decimalToPercentage = (decimal) => {
  if (typeof decimal !== "number" || isNaN(decimal)) return "0.00%";
  return `${(decimal * 100).toFixed(2)}%`;
};

export const percentageToDecimal = (percentageStr) => {
  if (typeof percentageStr !== "string") return 0;
  const cleanedStr = percentageStr.replace("%", "").trim();
  const parsed = parseFloat(cleanedStr);
  if (isNaN(parsed)) return 0;
  return parsed / 100;
};

export const numberToText = (num) => {
  if (typeof num !== "number" || isNaN(num)) return "0.00";
  return num.toFixed(2);
};

export const numToCurrency = (value, decim = 2, curr = "$") => {
  return (
    curr +
    Number(value).toLocaleString(undefined, {
      minimumFractionDigits: decim,
      maximumFractionDigits: decim,
    })
  );
  return curr + Number(value).toFixed(decim);
};

export const decimToPercent = (value, decim = 2) => {
  return Number(value * 100).toFixed(decim) + "%";
};
